/**
 * Extract file name and file extension from path string.
 *
 * @param {string} url Path to file.
 * @returns {string[]} Tuple of 2 string values: "[filename, extension]"
 *
 * @example
 * // Returns "['my.page', 'pdf']"
 * getFileNameFromUrl('https://example.com/my/my.page.pdf');
 */
export function getFileNameFromUrl(url) {
    if (!url || typeof url !== 'string') {
        return ['', ''];
    }
    let parsedUrl = url;
    /*
     * break URL at ? and take first part
     * so this: `page#hash?key=value`
     * will become this: `page#hash`
     * */
    parsedUrl = parsedUrl.split('?')[0];
    /*
     * break URL at # and take first part
     * so this: `page#hash`
     * will become this: `page`
     * */
    parsedUrl = parsedUrl.split('#')[0];
    /*
     * split pathname by `/` and get last element from array,
     * so this: `/my/page`
     * will become this: `page`
     * */
    const pathnameArray = parsedUrl.split('/');
    const name = pathnameArray[pathnameArray.length - 1];
    if (!name.includes('.')) {
        return [name, ''];
    }
    /*
     * in case if filename will contain several dots (.),
     * we will split string to array and take only last element
     * so this: `very-long.pdf.filename.jpg`
     * will become this: `.jpg`
     * */
    const nameSplitByDots = name.split('.');
    const [extension, ...filename] = nameSplitByDots.reverse();
    return [filename.reverse().join('.'), extension.toLocaleLowerCase()];
}
